var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.cmptData.cmpt,
    {
      tag: "components",
      class: _vm.cmptData.class,
      attrs: { plain: "" },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [_vm._v("\n  " + _vm._s(_vm.$t("pc_biz_core_btn_cancel")) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }